import { useEffect } from "react";
import { MotifIcon } from "@ey-xd/motif-react";
import "./Home.scss";
import { IconoirShop, IconoirBook, IconoirOkrs } from "@ey-xd/motif-icon";
import { useLocation, useNavigate } from "react-router";
import { setOpportunityCodeInLocal } from "../../utils/common";

const Home = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const ocode = (new URLSearchParams(search).get("ocode") || "").trim();

    if (ocode) {
      setOpportunityCodeInLocal(ocode);
    }
  }, [search]);

  return (
    <div className="home-container-wrapper">
      <section className="home-container">
        <div className="home-content">
          <h1 className="home-title">Commercial Hub</h1>
          <p className="home-description">
            The Commercial Hub is your go-to platform to discover and select
            innovative technology products that enhance client engagements.
            Explore software, tools, and services that streamline processes,
            strengthen projects, and elevate your client interactions, all in
            one comprehensive platform.
          </p>
        </div>
        <section className="home-tile-container">
          <div
            onClick={() => navigate("/marketplace")}
            className="home-tile-card-wrapper"
          >
            <div className={"home-tile-card home-tile-default"}>
              <div className="home-tile-icon">
                <MotifIcon
                  iconFunction={IconoirShop}
                  size="24"
                  title="Marketplace"
                />
              </div>
              <h4 className="home-tile-title">Marketplace</h4>
              <p className="home-tile-description">
                Browse and purchase technology products and services from our
                comprehensive catalog.
              </p>
            </div>
          </div>
          <div
            onClick={() => navigate("/my-workspace/all-order-bundles")}
            className="home-tile-card-wrapper"
          >
            <div className={"home-tile-card home-tile-default"}>
              <div className="home-tile-icon">
                <MotifIcon
                  iconFunction={IconoirBook}
                  size="24"
                  title="My Workspace"
                />
              </div>
              <h4 className="home-tile-title">My Workspace</h4>
              <p className="home-tile-description">
                Access your personalized dashboard with your orders, favorites
                and recommended products.
              </p>
            </div>
          </div>
          <div
            onClick={() => navigate("/order-pipeline/estimates")}
            className="home-tile-card-wrapper"
          >
            <div className={"home-tile-card home-tile-default"}>
              <div className="home-tile-icon">
                <MotifIcon
                  iconFunction={IconoirOkrs}
                  size="24"
                  title="Order Pipeline"
                />
              </div>
              <h4 className="home-tile-title">Order Pipeline</h4>
              <p className="home-tile-description">
                Track and manage your orders, approvals and delivery status in
                real time.
              </p>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Home;
